/** Rubrique Raccourcis clavier : affiche et permet d'éditer les raccourcis de l'app. */
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { metaApi, parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';

const DEFAULTS = { search: 'mod+k', scanner: 'alt+shift+c' };
const ACTIONS = [
  { key: 'search', label: 'Recherche globale', help: 'Place le curseur dans la barre de recherche' },
  { key: 'scanner', label: 'Ouvrir le scanner', help: 'Va à l\u2019écran Scanner' },
];

// Affichage lisible : mod→⌘/Ctrl, alt→⌥, shift→⇧.
const pretty = (combo) => String(combo || '').split('+').map((p) => ({
  mod: '⌘', cmd: '⌘', meta: '⌘', ctrl: 'Ctrl', alt: '⌥', option: '⌥', shift: '⇧',
}[p.trim().toLowerCase()] || p.trim().toUpperCase())).join(' ');

export default function Raccourcis() {
  const [est, setEst] = useState(null);
  const [sc, setSc] = useState(DEFAULTS);
  useEffect(() => { metaApi.settings().then((e) => { setEst(e); setSc({ ...DEFAULTS, ...(e.shortcuts || {}) }); }); }, []);
  if (!est) return <Spinner />;

  const save = async () => { await parametresApi.updateEstablishment({ shortcuts: sc }); toast.success('Raccourcis enregistrés'); };
  const reset = () => setSc(DEFAULTS);

  // Capture d'une combinaison au clavier dans le champ.
  const onKeyCapture = (actionKey, e) => {
    e.preventDefault();
    const parts = [];
    if (e.metaKey || e.ctrlKey) parts.push('mod');
    if (e.altKey) parts.push('alt');
    if (e.shiftKey) parts.push('shift');
    const k = e.key.toLowerCase();
    if (!['control', 'meta', 'alt', 'shift'].includes(k)) parts.push(k.length === 1 ? k : k);
    if (parts.length && parts[parts.length - 1] && !['mod', 'alt', 'shift'].includes(parts[parts.length - 1])) {
      setSc((s) => ({ ...s, [actionKey]: parts.join('+') }));
    }
  };

  return (
    <div className="max-w-[640px]">
      <h2 className="font-title text-3xl mb-1">Raccourcis clavier</h2>
      <p className="text-[13px] text-n600 mb-5">Cliquez un champ puis tapez la combinaison souhaitée. « mod » = ⌘ (Mac) ou Ctrl (Windows).</p>
      <Card className="p-5 space-y-4" data-testid="shortcuts-card">
        {ACTIONS.map((a) => (
          <div key={a.key} className="flex items-center justify-between gap-4" data-testid={`shortcut-${a.key}`}>
            <div>
              <p className="text-[14px]">{a.label}</p>
              <p className="text-[12px] text-n500">{a.help}</p>
            </div>
            <div className="flex items-center gap-2">
              <input readOnly value={pretty(sc[a.key])} onKeyDown={(e) => onKeyCapture(a.key, e)}
                className="vd-input h-9 w-40 text-center cursor-pointer" data-testid={`shortcut-input-${a.key}`}
                placeholder="Tapez une combinaison" />
            </div>
          </div>
        ))}
        <div className="flex gap-2 pt-2">
          <Button variant="primary" onClick={save} data-testid="shortcuts-save">Enregistrer</Button>
          <Button onClick={reset} data-testid="shortcuts-reset">Valeurs par défaut</Button>
        </div>
      </Card>
      <p className="text-[12px] text-n500 mt-3">Par défaut : Recherche = ⌘ K · Scanner = ⌥ ⇧ C</p>
    </div>
  );
}
